import { Item } from "../../data-model/documentModalWithSideBav";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

export interface NccnGuideLinesPayload {
  order_id: string;
}

export interface NccnGuideLinesApiResponse {
  error: string | null;
  guidelines: Record<string, any[]>;
  j_codes: string[];
  message: string;
  order_id: string;
  status: string;
  success: boolean;
}

export interface NccnGuideLinesResponse {
  data: Item[];
}

export const transformNccnResponse = (
  apiResponse: NccnGuideLinesApiResponse,
): Item[] => {
  const items: Item[] = [];

  if (!apiResponse?.j_codes || apiResponse?.j_codes?.length === 0) {
    return items;
  }

  apiResponse.j_codes.forEach((jCode) => {
    const guidelines = apiResponse.guidelines[jCode] || [];
    const item = {
      id: jCode,
      description: jCode,
      documents: guidelines.map((guideline, index) => ({
        id: `${jCode}_${index}`,
        title: guideline.name || "",
        type: "nccn_guideline",
        path: guideline.gs_path || "",
        showPrevious: index > 0,
        showNext: index < guidelines.length - 1,
      })),
    };

    items.push(item);
  });

  return items;
};

export const getNccnGuideLines = async (
  payload: NccnGuideLinesPayload,
): Promise<NccnGuideLinesResponse> => {
  try {
    const token = await getBearerToken();
    if (!token) {
      throw new Error("Bearer token not available");
    }

    const response = await fetch(API_ENDPOINTS.FETCH_NCCN_GUIDELINES, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const apiResponse: NccnGuideLinesApiResponse = await response.json();

    const transformedData = transformNccnResponse(apiResponse);

    return { data: transformedData };
  } catch (error) {
    console.error("Error fetching NCCN guidelines:", error);
    throw error;
  }
};
